import { render, staticRenderFns } from "./ZTwoArrowSvg.vue?vue&type=template&id=0c3ff8f8&scoped=true"
import script from "./ZTwoArrowSvg.vue?vue&type=script&lang=js"
export * from "./ZTwoArrowSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3ff8f8",
  null
  
)

export default component.exports